export default {"src":"/_next/static/media/weatherunion-logo-dark.f6ef7a59.svg","height":36,"width":199,"blurWidth":0,"blurHeight":0};